import React, { FC } from "react";
import { readObj } from "Service/storage";
import { ReactComponent as User } from "Assets/user-removebg-preview.svg";
import SafeImage from "Components/UI/SafeImage/SafeImage";
type TProps = {
  className?: string;
};
export const Profile: FC<TProps> = ({ className }) => {
  const personalInfo = readObj("account");
  return (
    <>
      <SafeImage
        src={personalInfo?.profile_picture?.file}
        className={className}
        alt="User profile"
        fallback={<User className={className} />}
      />
    </>
  );
};
